import { subscribeToTimeSeriesData } from './subscribeToTimeSeriesData';
import { timeSeriesDataSession, assetSession, alarmsSession, } from '../sessions';
/**
 * Provider for SiteWise time series data
 */
export class SiteWiseTimeSeriesDataProvider {
    constructor(session, input) {
        this.update = () => { };
        this.session = session;
        this.input = input;
    }
    subscribe(observer) {
        const { session } = this;
        const { update, unsubscribe } = subscribeToTimeSeriesData(timeSeriesDataSession(session), assetSession(session), alarmsSession(session))(this.input, (timeSeriesData) => observer.next([timeSeriesData]));
        this.update = update;
        /** @todo move into datamodule namespace when sessions are supported on time series module */
        this.session.attachDataModuleSession({
            close: unsubscribe,
        });
    }
    updateSubscription(subscriptionUpdate) {
        this.update(subscriptionUpdate);
    }
    unsubscribe() {
        this.session.close();
    }
    updateViewport(viewport) {
        this.update({
            request: {
                settings: this.input.request.settings,
                viewport,
            },
        });
    }
}
